import React, {Component} from 'react'
import {base} from '../../base';

import '../../styles/css/CreatorAwards.css'
import ProgressButton from '../utils/ProgressButton'

class TriviaBigScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userAnswers: [],
            frozenVotingState: [],
            answers: [],
            questions: [],
            question: 0,
            currentGame: {},
            rotate: false,
            timerToKill: false,
            timerToKill2: false,
            // triviaGameOn: false,
            tenantVariables: {}
        };
    }

componentDidMount() {
    this.answerListRef = base.bindToState('userAnswers', {
        context: this,
        state: 'userAnswers',
        asArray: true,
    })
    this.currentTriviaGameRef = base.syncState('currentTriviaGame', {
      context: this,
      state: 'currentGame',
    })
    this.currentTriviaGameRef = base.listenTo('currentTriviaGame/startRotation', {
      context: this,
      state: 'startRotation',
      then(start){
        if(start){
          this.setState({
            rotate: true
          }, () => {
              this.startRotation();
          });
        } else {
          this.setState({
            question:0,
            rotate: false
          })
        }
      }
    })

    this.questionTextRef = base.bindToState(`currentTriviaGame/questions`, {
      context: this,
      state: 'questions'
    });

    // this.answersRef = base.bindToState(`currentTriviaGame/answers`, {
    //   context: this,
    //   state: 'answers'
    // })
    // this.triviaGameOnRef = base.listenTo('currentTrivia/active', {
    //   context: this,
    //   then(triviaState){
    //     this.setState({
    //       triviaGameOn: triviaState,
    //     })
    //   }
    // })
}

startRotation(){
  this.setTimeouts()
}

setTimeouts(){
  var secondsBetweenQuestions = this.state.currentGame.secondsBetweenQuestions || "2";
  var secondsShowingAnswer = this.state.currentGame.secondsShowingAnswer || "2";
  secondsBetweenQuestions = parseInt(secondsBetweenQuestions + "000", 10)
  secondsShowingAnswer = parseInt(secondsShowingAnswer + "000", 10)
  var vm = this;
  var thing = setTimeout(function (){
    if(vm.state.rotate){
      var currentGame = vm.state.currentGame;
      currentGame.questions[vm.state.question].shown = true
      vm.setState({
        currentGame: currentGame
      })
      if(parseInt(vm.state.question, 10) < vm.state.questions.length - 1 && vm.state.rotate){
       var thing2  = setTimeout(function(){
          var question = parseInt(vm.state.question, 10) + 1
          vm.setState({
            question: question,
          })
          vm.setTimeouts()
        }, secondsShowingAnswer)
        vm.setState({
          timerToKill2: thing2
        })
      }
    }
  }, secondsBetweenQuestions)
  this.setState({
    timerToKill: thing
  })
}

componentWillUnmount() {
    base.removeBinding(this.answerListRef);
    base.removeBinding(this.questionTextRef);
}

render() {
    var questions = this.state.currentGame.questions || [];
    var tenantVariables = this.props.variables || {};
    var cleanedAnswersArray = [];
    // var totalTriviaAnswers = 0;
    var question = this.state.question;
    if(!this.state.rotate){
      question = 0
    }
    var timetoKill = this.state.timerToKill;
    var timetoKill2 = this.state.timerToKill2;
    if(timetoKill && !this.state.rotate){
      clearTimeout(timetoKill)
    }
    if(timetoKill2 && !this.state.rotate){
      clearTimeout(timetoKill2)
    }
    var currentQuestion = {}
    var image = tenantVariables.leftOfScoreboardImage;
    if(questions.length > 0){
      currentQuestion = questions[question]
      cleanedAnswersArray = questions[question].answers
    }
    var questionText1 = "3.5rem"
    if(tenantVariables.questionsize1 && tenantVariables.questionsize1.trim().length > 0){
      questionText1 = tenantVariables.questionsize1 + "px"
    }
        // if(userAnswers.length > 0){
    //   totalTriviaAnswers = userAnswers.length
    //   var tempCount = {};
    //   for(var answer in userAnswers){
    //     var answerId = userAnswers[answer].answerId;
    //     if(tempCount[answerId]){
    //       tempCount[answerId]['count'] = tempCount[answerId]['count'] + 1;
    //     } else {
    //       tempCount[answerId] = {};
    //       tempCount[answerId]['count'] = 1;
    //       tempCount[answerId]['answerText'] = userAnswers[answer].answerText;
    //     }
    //   }
      // for(var add_answer in cleanedAnswersArray){
      //   if(tempCount[cleanedAnswersArray[add_answer].id]){
      //     cleanedAnswersArray[add_answer]['count'] = tempCount[cleanedAnswersArray[add_answer].id].count
      //   } else {
      //     cleanedAnswersArray[add_answer]['count'] = 0
      //   }
      // }
    // }
    return (
        <div className="grid-wrapper" style={{backgroundImage: "url(" + tenantVariables.scoreboardBackgroundImage + ")"}}>
            <div className="grid-container-outer">
                <div className="grid-left">
                    <div className="creator-awards-logo"><img src={image} alt=""/></div>
                </div>
                <center>
                    <h1 style={{color:tenantVariables.progressBarQuestionTextColor, marginBottom:"30px", fontSize:questionText1, fontWeight: "900"}}>{currentQuestion.questionText}</h1>
                    <div>
                      {
                          cleanedAnswersArray.map(function(item,i){
                            // var amountFilled = 0;
                            // if(totalTriviaAnswers > 0){
                            //   amountFilled = item.count / totalTriviaAnswers * 100;
                            // }
                            if(currentQuestion.shown && item.correct){
                              return (
                                  <div key={i} className="item-scoreboard">
                                  {/*
                                      <ProgressButton variables={this.state.tenantVariables} title={item.answerText} progress={amountFilled}/>
                                  */}
                                  <ProgressButton variables={tenantVariables} title={item.answerText} correct={true}/>
                                  </div>
                              )
                            } else {
                              return (
                                  <div key={i} className="item-scoreboard">
                                  {/*
                                      <ProgressButton variables={this.state.tenantVariables} title={item.answerText} progress={amountFilled}/>
                                  */}
                                  <ProgressButton variables={tenantVariables} title={item.answerText}/>
                                  </div>
                              )
                            }
                          }, this)
                        }
                    </div>
                </center>
            </div>
        </div>
      )
    }
}

export default TriviaBigScreen;



// WEBPACK FOOTER //
// ./src/components/main_screens/TriviaBigScreen.js